import { modalRenderer } from '~/modal/modalRendererRegistry';
import { WelcomeModalComponent } from './welcomeModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    Welcome: undefined;
  }
}

modalRenderer.register('Welcome', WelcomeModalComponent);
